// src/App.js
import React, { useState, useEffect } from 'react';
import './App.css';
import Navigation from './components/Navigation';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { Projects } from './components/Projects';
import { About } from './components/About';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { Seo } from './components/Seo';

const MAINTENANCE_MODE = false; // Set to true to enable maintenance mode

function MaintenancePage() {
  return (
    <>
      <style>{`
        @-moz-keyframes spin { 100% { -moz-transform: rotate(360deg); } }
        @-webkit-keyframes spin { 100% { -webkit-transform: rotate(360deg); } }
        @keyframes spin { 100% { -webkit-transform: rotate(360deg); transform:rotate(360deg); } }
      `}</style>
      <div style={{
        backgroundColor: '#191919',
        textAlign: 'center',
        padding: '150px',
        font: '20px Helvetica, sans-serif',
        color: '#fff',
        minHeight: '100vh'
      }}>
        <img
          id="img360"
          src="/images/icon-white.png"
          alt=""
          style={{
            borderRadius: '100px',
            animation: 'spin 4s linear infinite',
            display: 'block',
            margin: '0 auto 20px'
          }}
        />
        <h1 style={{ fontSize: '50px', color: '#fff' }}>Sorry we're down for maintenance.</h1>
        <h2 style={{ color: '#fff' }}>We'll be back shortly.</h2>
      </div>
    </>
  );
}

function App() {
  const [darkMode, setDarkMode] = useState(false);
  const [language, setLanguage] = useState('en');

  // Inisialisasi tema dan bahasa saat pertama kali render
  useEffect(() => {
    // Cek preferensi tema
    const savedTheme = localStorage.getItem('theme');
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    const initialTheme = savedTheme ? savedTheme === 'dark' : prefersDark;
    setDarkMode(initialTheme);

    // Cek preferensi bahasa
    const savedLanguage = localStorage.getItem('language') || 'en';
    setLanguage(savedLanguage);
  }, []);

  // Terapkan tema ke <html> setiap kali darkMode berubah
  useEffect(() => {
    if (darkMode) {
      document.documentElement.classList.add('dark');
      localStorage.setItem('theme', 'dark');
    } else {
      document.documentElement.classList.remove('dark');
      localStorage.setItem('theme', 'light');
    }
  }, [darkMode]);

  // Handle language change dari Navigation
  const handleLanguageChange = (newLanguage) => {
    setLanguage(newLanguage);
    localStorage.setItem('language', newLanguage);
  };

  const toggleDarkMode = () => {
    setDarkMode(prev => !prev);
  };

  if (MAINTENANCE_MODE) {
    return <MaintenancePage />;
  }

  return (
    <div className="App">
      <Seo language={language} />
      <Navigation 
        darkMode={darkMode} 
        toggleDarkMode={toggleDarkMode} 
        language={language}
        onLanguageChange={handleLanguageChange}
      />
      <Hero language={language} />
      <Services language={language} />
      <Projects language={language} />
      <About language={language} />
      <Contact language={language} />
      <Footer language={language} />
    </div>
  );
}

export default App;